import { useMemo } from "react";

export interface SEOProps {
  json_ld?: string;
}

export default function SEO(props: SEOProps) {
  const { json_ld = {} } = props;

  const content = useMemo(() => {
    return [
      json_ld && (
        <script
        key={0}
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(json_ld) }}
        />
      ),
    ].filter(Boolean);
  }, [json_ld]);

  return content;
}
